/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Why_TitleInputs */

const en_landing_why_title = /** @type {(inputs: Landing_Why_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The facts behind Ideogram AI 4.5`)
};

const zh_landing_why_title = /** @type {(inputs: Landing_Why_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ideogram AI 4.5 的关键事实`)
};

/**
* | output |
* | --- |
* | "The facts behind Ideogram AI 4.5" |
*
* @param {Landing_Why_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_why_title = /** @type {((inputs?: Landing_Why_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Why_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_why_title(inputs)
	return zh_landing_why_title(inputs)
});
export { landing_why_title as "landing.why.title" }